import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { GiHamburgerMenu } from 'react-icons/gi';
import { IoMdClose } from 'react-icons/io';
import emailjs from "@emailjs/browser";




const Hadear = () => {
  const [toggle, setToggle] = useState(false);

  const CloseClick = () => {
    setToggle(false);

  };
  const [ismobile, setIsmobile] = useState(0);

  // const { categorytotal } = useSelector((store) => store.categoryAll);


  const [showAbout, setShowAbout] = useState(true);
  const [showInterior, setShowInterior] = useState(true);
  const [showGallery, setShowGallery] = useState(true);

  const closemenu = () => {
    document.getElementById("mytogglebtn").classList.add("collapsed");
    document.getElementById("menu").classList.remove("in");
  };



  const [name, setName] = useState("");
  const [mail, setmail] = useState("");
  const [massages, setMassages] = useState("");
  const [number, setNumber] = useState("");
  const [state, setState] = useState("");
  const [subject, setSubject] = useState("");
  const [city, setCity] = useState("");

  const nameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };
  const stateChange = (e) => {
    const value = e.target.value;
    setState(value);
  };
  const cityChange = (e) => {
    const value = e.target.value;
    setCity(value);
  };
  const subjectChange = (e) => {
    const value = e.target.value;
    setSubject(value);
  };
  const numberChange = (e) => {
    const value = e.target.value;
    setNumber(value);
  };

  const mailChange = (e) => {
    const value = e.target.value;
    setmail(value);
  };
  const massagesChange = (e) => {
    const value = e.target.value;
    setMassages(value);
  };


  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(

      // "service_oumku8k",
      // "template_esy4tqm",
      // "#myForm",
      // "8i7i_APkS7sZ9CqPl"
    )
      .then(
        function (response) {
          console.log("SUCCESS!", response.status, response.text);
          if (response.text === "OK") {
            setName("");
            setmail("");
            setMassages("");
            setNumber("");
            setState("");
            setSubject("");
            setCity("");

          }
        },
        function (error) {
          console.log("FAILED...", error);
        }
      );
  };


  return (
    <>

        <div className="container-fluid bg-primary px-5 d-none d-lg-block">
          <div className="row gx-0 align-items-center">
            <div className="col-lg-5 text-center text-lg-start mb-lg-0">
              <div className="d-flex">
                {/* <a to="#" className="text-muted me-4" style={{color:"white"}}><i className="fas fa-envelope text-secondary me-2" style={{color:"white"}} />Example@gmail.com</a> */}
                <a href="tel:+91 7389578180" style={{color:"white"}} className="me-0"><i className="fas fa-phone-alt text-secondary me-2" />+91 7389578180</a>
              </div>
            </div>
            <div className="col-lg-3 row-cols-1 text-center mb-2 mb-lg-0">
              <div className="d-inline-flex align-items-center" style={{ height: 45 }}>
                {/* <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" to><i className="fab fa-twitter fw-normal text-secondary" /></a> */}
                <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" href='https://www.instagram.com/shiv_travels_8180?igsh=M2YzcHNzdWYwY29j' target="_blank" ><i className="fab fa-instagram fw-normal text-secondary" /></a>
                <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" to><i className="fab fa-facebook-f fw-normal text-secondary" /></a>
                {/* <a className="btn btn-sm btn-outline-light btn-square rounded-circle me-2" to><i className="fab fa-linkedin-in fw-normal text-secondary" /></a> */}
                <a className="btn btn-sm btn-outline-light btn-square rounded-circle" to><i className="fab fa-youtube fw-normal text-secondary" /></a>
              </div>
            </div>
            {/* <div className="col-lg-4 text-center text-lg-end">
              <div className="d-inline-flex align-items-center" style={{ height: 45 }}>
                <a to="#" className="text-muted me-2"> Help</a><small> / </small>
                <a to="#" className="text-muted mx-2"> Support</a><small> / </small>
                <a to="#" className="text-muted ms-2"> Contact</a>
              </div>
            </div> */}
          </div>
        </div>
        <div className="container-fluid nav-bar p-0" >
          <nav className="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0" style={{backgroundColor:"#ffffffff"}} >
            <Link to="/" className="navbar-brand p-0" >
              <h1 className="display-5 text-secondary m-0" ><img src="./assets/img/logo_2.png" className="img-fluid" alt />
              {/* <p style={{fontSize:"17px",  textAlign:"center", fontFamily:"sans-serif", marginTop:"9px", marginBottom:"9px", textShadow:"2px 2px 2px #000000", color:"#e5b900"}}>M.S. Group</p> */}
              </h1>
              {/* <img src="img/logo.png" alt="Logo"> */}
            </Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
              <span className="fa fa-bars" />
            </button>
            <div className="collapse navbar-collapse" id="navbarCollapse" >
              <div className="navbar-nav ms-auto py-0">
                <Link to="/" className="nav-item nav-link active" onClick={closemenu} style={{color:"#000000"}}>Home</Link>
                <Link to="/about" className="nav-item nav-link" onClick={closemenu} style={{color:"#000000"}}>About Us</Link>
                <Link to="/our-vehicles" className="nav-item nav-link" onClick={closemenu} style={{color:"#000000"}}>Our Vehicles</Link>
                {/* <div className="nav-item dropdown">
                  <a to="#" className="nav-link" data-bs-toggle="dropdown"><span className="dropdown-toggle">Pages</span></a>
                  <div className="dropdown-menu m-0">
                    <a to="feature.html" className="dropdown-item">Feature</a>
                    <a to="countries.html" className="dropdown-item">Countries</a>
                    <a to="testimonial.html" className="dropdown-item">Testimonial</a>
                    <a to="training.html" className="dropdown-item">Training</a>
                    <a to="404.html" className="dropdown-item">404 Page</a>
                  </div>
                </div> */}
                <Link to="/contact-us" className="nav-item nav-link" onClick={closemenu} style={{color:"#000000"}}>Contact Us</Link>
              </div>
              {/* <button className="btn btn-primary btn-md-square border-secondary mb-3 mb-md-3 mb-lg-0 me-3" data-bs-toggle="modal" data-bs-target="#searchModal"><i className="fas fa-search" /></button> */}
              <Link to="/contact-us" className="btn btn-primary border-secondary rounded-pill py-2 px-4 px-lg-3 mb-3 mb-md-3 mb-lg-0" onClick={closemenu}>Get A
                Quote</Link>
            </div>
          </nav>
        </div>
        
    </>
  )
}

export default Hadear